export const ChatSidebar = {
  flow: 'y',
  width: 'F3',
  background: 'inkMid',
  borderRight: '1px solid inkBorder',
  height: '100vh',
  position: 'sticky',
  top: '0',
  overflow: 'auto',
  '@mobileL': { display: 'none' },

  Header: {
    padding: 'A',
    borderBottom: '1px solid inkBorder',
    Title: {
      text: '{{ teamChat | polyglot }}',
      fontSize: 'A',
      fontWeight: '700',
      color: 'inkText'
    }
  },

  ChannelsSection: {
    flow: 'y',
    gap: '0',
    padding: 'Z 0',
    SectionLabel: {
      text: '{{ channels | polyglot }}',
      fontSize: 'Y',
      fontWeight: '600',
      color: 'inkMuted',
      letterSpacing: 'X',
      padding: 'Y A',
      textTransform: 'uppercase'
    },

    ChannelCabinet1: {
      flow: 'x',
      align: 'center space-between',
      padding: 'Y A',
      cursor: 'pointer',
      transition: 'background 150ms ease',
      background: (el, s) =>
        s.root.activeChatChannel === 'cabinet-1' ? 'teal.15' : 'transparent',
      ':hover': { background: 'teal.08' },
      Left: {
        flow: 'x',
        gap: 'Y',
        align: 'center flex-start',
        Hash: {
          text: '#',
          fontSize: 'Z',
          fontWeight: '700',
          color: (el, s) =>
            s.root.activeChatChannel === 'cabinet-1' ? 'teal' : 'inkMuted'
        },
        Label: {
          text: '{{ cabinet1 | polyglot }}',
          fontSize: 'Z',
          fontWeight: (el, s) =>
            s.root.activeChatChannel === 'cabinet-1' ? '600' : '400',
          color: (el, s) =>
            s.root.activeChatChannel === 'cabinet-1' ? 'teal' : 'inkText'
        }
      },
      Badge: {
        text: '3',
        fontSize: 'Y',
        fontWeight: '700',
        padding: 'W Y',
        round: 'Z',
        background: 'teal',
        color: 'white',
        minWidth: 'A',
        textAlign: 'center'
      },
      onClick: (e, el, s) => s.root.update({ activeChatChannel: 'cabinet-1' })
    },

    ChannelCabinet2: {
      flow: 'x',
      align: 'center space-between',
      padding: 'Y A',
      cursor: 'pointer',
      transition: 'background 150ms ease',
      background: (el, s) =>
        s.root.activeChatChannel === 'cabinet-2' ? 'teal.15' : 'transparent',
      ':hover': { background: 'teal.08' },
      Left: {
        flow: 'x',
        gap: 'Y',
        align: 'center flex-start',
        Hash: {
          text: '#',
          fontSize: 'Z',
          fontWeight: '700',
          color: (el, s) =>
            s.root.activeChatChannel === 'cabinet-2' ? 'teal' : 'inkMuted'
        },
        Label: {
          text: '{{ cabinet2 | polyglot }}',
          fontSize: 'Z',
          fontWeight: (el, s) =>
            s.root.activeChatChannel === 'cabinet-2' ? '600' : '400',
          color: (el, s) =>
            s.root.activeChatChannel === 'cabinet-2' ? 'teal' : 'inkText'
        }
      },
      onClick: (e, el, s) => s.root.update({ activeChatChannel: 'cabinet-2' })
    },

    ChannelReception: {
      flow: 'x',
      align: 'center space-between',
      padding: 'Y A',
      cursor: 'pointer',
      transition: 'background 150ms ease',
      background: (el, s) =>
        s.root.activeChatChannel === 'reception' ? 'teal.15' : 'transparent',
      ':hover': { background: 'teal.08' },
      Left: {
        flow: 'x',
        gap: 'Y',
        align: 'center flex-start',
        Hash: {
          text: '#',
          fontSize: 'Z',
          fontWeight: '700',
          color: (el, s) =>
            s.root.activeChatChannel === 'reception' ? 'teal' : 'inkMuted'
        },
        Label: {
          text: '{{ reception | polyglot }}',
          fontSize: 'Z',
          fontWeight: (el, s) =>
            s.root.activeChatChannel === 'reception' ? '600' : '400',
          color: (el, s) =>
            s.root.activeChatChannel === 'reception' ? 'teal' : 'inkText'
        }
      },
      Badge: {
        text: '5',
        fontSize: 'Y',
        fontWeight: '700',
        padding: 'W Y',
        round: 'Z',
        background: 'red',
        color: 'white',
        minWidth: 'A',
        textAlign: 'center'
      },
      onClick: (e, el, s) => s.root.update({ activeChatChannel: 'reception' })
    },

    ChannelDoctors: {
      flow: 'x',
      align: 'center space-between',
      padding: 'Y A',
      cursor: 'pointer',
      transition: 'background 150ms ease',
      background: (el, s) =>
        s.root.activeChatChannel === 'doctors' ? 'teal.15' : 'transparent',
      ':hover': { background: 'teal.08' },
      Left: {
        flow: 'x',
        gap: 'Y',
        align: 'center flex-start',
        Hash: {
          text: '#',
          fontSize: 'Z',
          fontWeight: '700',
          color: (el, s) =>
            s.root.activeChatChannel === 'doctors' ? 'teal' : 'inkMuted'
        },
        Label: {
          text: '{{ doctors | polyglot }}',
          fontSize: 'Z',
          fontWeight: (el, s) =>
            s.root.activeChatChannel === 'doctors' ? '600' : '400',
          color: (el, s) =>
            s.root.activeChatChannel === 'doctors' ? 'teal' : 'inkText'
        }
      },
      Badge: {
        text: '1',
        fontSize: 'Y',
        fontWeight: '700',
        padding: 'W Y',
        round: 'Z',
        background: 'amber',
        color: 'white',
        minWidth: 'A',
        textAlign: 'center'
      },
      onClick: (e, el, s) => s.root.update({ activeChatChannel: 'doctors' })
    },

    ChannelManagement: {
      flow: 'x',
      align: 'center space-between',
      padding: 'Y A',
      cursor: 'pointer',
      transition: 'background 150ms ease',
      background: (el, s) =>
        s.root.activeChatChannel === 'management' ? 'teal.15' : 'transparent',
      ':hover': { background: 'teal.08' },
      Left: {
        flow: 'x',
        gap: 'Y',
        align: 'center flex-start',
        Hash: {
          text: '#',
          fontSize: 'Z',
          fontWeight: '700',
          color: (el, s) =>
            s.root.activeChatChannel === 'management' ? 'teal' : 'inkMuted'
        },
        Label: {
          text: '{{ management | polyglot }}',
          fontSize: 'Z',
          fontWeight: (el, s) =>
            s.root.activeChatChannel === 'management' ? '600' : '400',
          color: (el, s) =>
            s.root.activeChatChannel === 'management' ? 'teal' : 'inkText'
        }
      },
      onClick: (e, el, s) => s.root.update({ activeChatChannel: 'management' })
    },

    ChannelGeneral: {
      flow: 'x',
      align: 'center space-between',
      padding: 'Y A',
      cursor: 'pointer',
      transition: 'background 150ms ease',
      background: (el, s) =>
        s.root.activeChatChannel === 'general' ? 'teal.15' : 'transparent',
      ':hover': { background: 'teal.08' },
      Left: {
        flow: 'x',
        gap: 'Y',
        align: 'center flex-start',
        Hash: {
          text: '#',
          fontSize: 'Z',
          fontWeight: '700',
          color: (el, s) =>
            s.root.activeChatChannel === 'general' ? 'teal' : 'inkMuted'
        },
        Label: {
          text: '{{ general | polyglot }}',
          fontSize: 'Z',
          fontWeight: (el, s) =>
            s.root.activeChatChannel === 'general' ? '600' : '400',
          color: (el, s) =>
            s.root.activeChatChannel === 'general' ? 'teal' : 'inkText'
        }
      },
      onClick: (e, el, s) => s.root.update({ activeChatChannel: 'general' })
    }
  },

  DirectMessagesSection: {
    flow: 'y',
    gap: '0',
    padding: 'Z 0',
    borderTop: '1px solid inkBorder',
    SectionLabel: {
      text: '{{ directMessages | polyglot }}',
      fontSize: 'Y',
      fontWeight: '600',
      color: 'inkMuted',
      letterSpacing: 'X',
      padding: 'Y A',
      textTransform: 'uppercase'
    },

    DmKvaratskhelia: {
      flow: 'x',
      align: 'center space-between',
      padding: 'Y A',
      cursor: 'pointer',
      transition: 'background 150ms ease',
      background: (el, s) =>
        s.root.activeChatChannel === 'dm-kvaratskhelia'
          ? 'teal.15'
          : 'transparent',
      ':hover': { background: 'teal.08' },
      Left: {
        flow: 'x',
        gap: 'Y',
        align: 'center flex-start',
        Avatar: {
          text: 'GK',
          fontSize: 'Y',
          fontWeight: '700',
          width: 'B',
          height: 'B',
          round: 'B',
          background: 'teal.15',
          color: 'teal',
          display: 'flex',
          align: 'center center'
        },
        Info: {
          flow: 'y',
          gap: '0',
          Name: {
            text: 'Dr. Kvaratskhelia',
            fontSize: 'Z',
            fontWeight: (el, s) =>
              s.root.activeChatChannel === 'dm-kvaratskhelia' ? '600' : '400',
            color: (el, s) =>
              s.root.activeChatChannel === 'dm-kvaratskhelia'
                ? 'teal'
                : 'inkText'
          },
          Status: {
            text: '{{ online | polyglot }}',
            fontSize: 'Y',
            color: 'green'
          }
        }
      },
      onClick: (e, el, s) =>
        s.root.update({ activeChatChannel: 'dm-kvaratskhelia' })
    },

    DmBeridze: {
      flow: 'x',
      align: 'center space-between',
      padding: 'Y A',
      cursor: 'pointer',
      transition: 'background 150ms ease',
      background: (el, s) =>
        s.root.activeChatChannel === 'dm-beridze' ? 'teal.15' : 'transparent',
      ':hover': { background: 'teal.08' },
      Left: {
        flow: 'x',
        gap: 'Y',
        align: 'center flex-start',
        Avatar: {
          text: 'NB',
          fontSize: 'Y',
          fontWeight: '700',
          width: 'B',
          height: 'B',
          round: 'B',
          background: 'purple.15',
          color: 'purple',
          display: 'flex',
          align: 'center center'
        },
        Info: {
          flow: 'y',
          gap: '0',
          Name: {
            text: 'Dr. Beridze',
            fontSize: 'Z',
            fontWeight: (el, s) =>
              s.root.activeChatChannel === 'dm-beridze' ? '600' : '400',
            color: (el, s) =>
              s.root.activeChatChannel === 'dm-beridze' ? 'teal' : 'inkText'
          },
          Status: {
            text: '{{ online | polyglot }}',
            fontSize: 'Y',
            color: 'green'
          }
        }
      },
      Badge: {
        text: '2',
        fontSize: 'Y',
        fontWeight: '700',
        padding: 'W Y',
        round: 'Z',
        background: 'teal',
        color: 'white',
        minWidth: 'A',
        textAlign: 'center'
      },
      onClick: (e, el, s) => s.root.update({ activeChatChannel: 'dm-beridze' })
    },

    DmNino: {
      flow: 'x',
      align: 'center space-between',
      padding: 'Y A',
      cursor: 'pointer',
      transition: 'background 150ms ease',
      background: (el, s) =>
        s.root.activeChatChannel === 'dm-nino' ? 'teal.15' : 'transparent',
      ':hover': { background: 'teal.08' },
      Left: {
        flow: 'x',
        gap: 'Y',
        align: 'center flex-start',
        Avatar: {
          text: 'NT',
          fontSize: 'Y',
          fontWeight: '700',
          width: 'B',
          height: 'B',
          round: 'B',
          background: 'amber.15',
          color: 'amber',
          display: 'flex',
          align: 'center center'
        },
        Info: {
          flow: 'y',
          gap: '0',
          Name: {
            text: '{{ hygienistNino | polyglot }}',
            fontSize: 'Z',
            fontWeight: (el, s) =>
              s.root.activeChatChannel === 'dm-nino' ? '600' : '400',
            color: (el, s) =>
              s.root.activeChatChannel === 'dm-nino' ? 'teal' : 'inkText'
          },
          Status: {
            text: '{{ away | polyglot }}',
            fontSize: 'Y',
            color: 'amber'
          }
        }
      },
      onClick: (e, el, s) => s.root.update({ activeChatChannel: 'dm-nino' })
    }
  }
}
